<template>
  <v-card width="100%" height="auto" flat>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-row class="mx-0">
        <v-col cols="12">
          <v-text-field
            v-model="invoiceSubtitle"
            :label="$t('invoiceSubtitle')"
            :rules="[(v) => !!v || $t('is-required')]"
            outlined
            placeholder=""
            clearable
            hide-details
            dense
          />
        </v-col>
        <v-col cols="12" class="my-0 py-0" style="height: auto !important">
          <tiptap-vuetify
            v-model="invoiceContent"
            :extensions="extensions"
            :toolbar-attributes="{ color: '#ababab', dark: true }"
          />
        </v-col>
      </v-row>
      <v-row class="mx-0 upload-row" align="center">
        <v-col cols="12" class="py-2 upload-col">
          <div class="upload-line">
            <v-checkbox
              v-model="companySignatureEnabled"
              label="امضای شرکت"
              :true-value="'active'"
              :false-value="'deactive'"
              hide-details
              dense
              class="mt-0 upload-checkbox"
            />
            <div class="upload-zone" @click="triggerSignatureUpload">
              <v-img
                v-if="companySignaturePreviewUrl"
                :src="companySignaturePreviewUrl"
                max-height="32"
                max-width="48"
                contain
                class="upload-zone__preview"
              />
              <span
                v-else
                class="upload-zone__text"
                :class="{ 'upload-zone__text--filled': companySignatureFileName }"
              >
                {{ companySignatureFileName || "بارگذاری امضا" }}
              </span>
              <div class="upload-zone__icon">
                <v-icon
                  v-if="hasSignatureFile"
                  @click.stop="clearSignatureUpload"
                  color="#9e9e9e"
                >
                  mdi-close
                </v-icon>
                <v-icon color="#9e9e9e"> mdi-upload </v-icon>
              </div>

              <input
                ref="signatureInput"
                type="file"
                accept="image/*"
                class="upload-zone__input"
                @change="onSignatureFile"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="mx-0 upload-row" align="center">
        <v-col cols="12" class="py-2 upload-col">
          <div class="upload-line">
            <v-checkbox
              v-model="companyStampEnabled"
              label="مهر شرکت"
              :true-value="'active'"
              :false-value="'deactive'"
              hide-details
              dense
              class="mt-0 upload-checkbox"
            />
            <div class="ms-4 upload-zone" @click="triggerStampUpload">
              <v-img
                v-if="companyStampPreviewUrl"
                :src="companyStampPreviewUrl"
                max-height="32"
                max-width="48"
                contain
                class="upload-zone__preview"
              />
              <span
                v-else
                class="upload-zone__text"
                :class="{ 'upload-zone__text--filled': companyStampFileName }"
              >
                {{ companyStampFileName || "بارگذاری مهر شرکت" }}
              </span>
              <div class="upload-zone__icon">
                <v-icon
                  v-if="hasStampFile"
                  @click.stop="clearStampUpload"
                  color="#9e9e9e"
                >
                  mdi-close
                </v-icon>
                <v-icon color="#9e9e9e"> mdi-upload </v-icon>
              </div>
              <input
                ref="stampInput"
                type="file"
                accept="image/*"
                class="upload-zone__input"
                @change="onStampFile"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6" class="px-1">
            <v-btn color="primary" class="mr-0" :loading="isLoading" @click="onSubmit">
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn color="grey" outlined class="float-left" @click="$emit('close')">
              {{ $t("cancel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from "../../../../../Mixins/general";
import {
  // component
  TiptapVuetify,
  // extensions
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from "tiptap-vuetify";
export default {
  name: "Customer",
  components: {
    TiptapVuetify,
  },
  mixins: [General],
  data: () => ({
    valid: true,
    extensions: [
      History,
      Table,
      TableCell,
      TableHeader,
      TableRow,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem, // if you need to use a list (BulletList, OrderedList)
      BulletList,
      OrderedList,
      Image,
      [
        Heading,
        {
          // Options that fall into the tiptap's extension
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak, // line break on Shift + Ctrl + Enter
    ],
    invoiceSubtitle: null,
    invoiceContent: null,
    companySignatureEnabled: "deactive",
    companyStampEnabled: "deactive",
    companySignatureFile: null,
    companyStampFile: null,
    companySignatureFileName: null,
    companyStampFileName: null,
    companySignatureVal: null,
    companyStampVal: null,
    companySignaturePreviewUrl: null,
    companyStampPreviewUrl: null,
    paymentZibalSystem: null,
    paymentZibalAccountName: null,
    paymentZibalAccountShaba: null,
    paymentZibalConfirm: false,
    select: "invoicePrint",
    lists: [],
    render: false,
    isLoading: false,
  }),
  watch: {},
  activated() {
    this.show();
  },
  computed: {
    hasSignatureFile() {
      return !!(
        this.companySignatureFile ||
        this.companySignatureVal ||
        this.companySignatureFileName ||
        this.companySignaturePreviewUrl
      );
    },
    hasStampFile() {
      return !!(
        this.companyStampFile ||
        this.companyStampVal ||
        this.companyStampFileName ||
        this.companyStampPreviewUrl
      );
    },
  },
  beforeMount() {
    this.statusItems = [
      {
        value: "not_completed",
        text: this.$t("not_completed"),
      },
      {
        value: "canceled",
        text: this.$t("canceled"),
      },
      {
        value: "not_completed",
        text: this.$t("not_completed"),
      },
      {
        value: "unfulfilled",
        text: this.$t("unfulfilled"),
      },
      {
        value: "fulfilled",
        text: this.$t("fulfilled"),
      },
    ];
  },
  mounted() {
    this.show();
  },
  methods: {
    clearSignatureUpload() {
      if (
        this.companySignaturePreviewUrl &&
        this.companySignaturePreviewUrl.startsWith("blob:")
      ) {
        URL.revokeObjectURL(this.companySignaturePreviewUrl);
      }
      this.companySignatureFile = null;
      this.companySignatureFileName = null;
      this.companySignatureVal = null;
      this.companySignaturePreviewUrl = null;
      if (this.$refs.signatureInput) {
        this.$refs.signatureInput.value = "";
      }
    },
    clearStampUpload() {
      if (
        this.companyStampPreviewUrl &&
        this.companyStampPreviewUrl.startsWith("blob:")
      ) {
        URL.revokeObjectURL(this.companyStampPreviewUrl);
      }
      this.companyStampFile = null;
      this.companyStampFileName = null;
      this.companyStampVal = null;
      this.companyStampPreviewUrl = null;
      if (this.$refs.stampInput) {
        this.$refs.stampInput.value = "";
      }
    },
    addPaymentMethod() {
      this.paymentItems.push({
        bank: null,
        value: null,
      });
    },
    remove(index) {
      this.paymentItems.splice(index, 1);
    },
    triggerSignatureUpload() {
      this.$refs.signatureInput.click();
    },
    triggerStampUpload() {
      this.$refs.stampInput.click();
    },
    onSignatureFile(e) {
      const file = e.target.files && e.target.files[0];
      this.companySignatureFile = file || null;
      this.companySignatureFileName = file ? file.name : null;
      this.companySignaturePreviewUrl = file
        ? URL.createObjectURL(file)
        : this.companySignatureVal?.link || null;
    },
    onStampFile(e) {
      const file = e.target.files && e.target.files[0];
      this.companyStampFile = file || null;
      this.companyStampFileName = file ? file.name : null;
      this.companyStampPreviewUrl = file
        ? URL.createObjectURL(file)
        : this.companyStampVal?.link || null;
    },
    parseActiveDeactive(value) {
      if (value === "active" || value === true || value === 1 || value === "1") {
        return "active";
      }
      return "deactive";
    },
    getFileDisplayName(file) {
      if (!file) return null;
      if (typeof file === "string") return file;
      return file.title || file.name || file.fileName || null;
    },
    getFilePreviewUrl(file) {
      if (!file || typeof file === "string") return null;
      return file.link || file.url || null;
    },
    applyStoredUploadFile(file, kind) {
      if (!file) return;
      const name = this.getFileDisplayName(file);
      const preview = this.getFilePreviewUrl(file);
      if (kind === "signature") {
        this.companySignatureVal = file;
        this.companySignatureFileName = name;
        this.companySignaturePreviewUrl = preview;
      } else {
        this.companyStampVal = file;
        this.companyStampFileName = name;
        this.companyStampPreviewUrl = preview;
      }
    },
    resetUploadFields() {
      this.companySignatureFile = null;
      this.companyStampFile = null;
      this.companySignatureFileName = null;
      this.companyStampFileName = null;
      this.companySignatureVal = null;
      this.companyStampVal = null;
      this.companySignaturePreviewUrl = null;
      this.companyStampPreviewUrl = null;
    },
    normalizeInvoicePrintData(res) {
      if (!res) return null;
      if (
        res.data != null &&
        typeof res.data === "object" &&
        res.subtitle == null &&
        res.content == null
      ) {
        return res.data;
      }
      return res;
    },
    applyInvoicePrintResponse(res) {
      const data = this.normalizeInvoicePrintData(res);
      if (!data) return;

      this.invoiceSubtitle =
        data.subtitle != null
          ? data.subtitle
          : data.invoice_subtitle != null
          ? data.invoice_subtitle
          : data.invoiceSubtitle;
      this.invoiceContent =
        data.content != null
          ? data.content
          : data.invoice_content != null
          ? data.invoice_content
          : data.invoiceContent;

      const sigEnabled =
        data.companySignatureEnabled != null
          ? data.companySignatureEnabled
          : data.company_signature_enabled != null
          ? data.company_signature_enabled
          : data.signature_enabled;
      const stampEnabled =
        data.companyStampEnabled != null
          ? data.companyStampEnabled
          : data.company_stamp_enabled != null
          ? data.company_stamp_enabled
          : data.stamp_enabled;

      this.companySignatureEnabled = this.parseActiveDeactive(sigEnabled);
      this.companyStampEnabled = this.parseActiveDeactive(stampEnabled);

      const sigFile =
        data.signature ||
        data.companySignature ||
        data.company_signature ||
        data.signature_file ||
        data.signatureFile;
      const stampFile =
        data.stamp ||
        data.companyStamp ||
        data.company_stamp ||
        data.stamp_file ||
        data.stampFile;

      this.applyStoredUploadFile(sigFile, "signature");
      this.applyStoredUploadFile(stampFile, "stamp");

      if (Array.isArray(data.files)) {
        data.files.forEach((file) => {
          const type = (file.type || file.file_type || "").toLowerCase();
          if (type === "signature") this.applyStoredUploadFile(file, "signature");
          if (type === "stamp") this.applyStoredUploadFile(file, "stamp");
        });
      }
    },
    create() {
      if (!this.$refs.form.validate()) return false;
      var app = this;
      app.isLoading = true;
      return app.$axios
        .post(this.$endpoint + "setting", this.$data)
        .then((res) => {
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          return res;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
          return Promise.reject(err);
        });
    },
    onSubmit() {
      var app = this;
      const created = app.create();
      if (created === false) return false;
      created
        .then(() => app.uploadCompanySignatureAndStamp())
        .catch(() => {})
        .finally(() => {
          app.isLoading = false;
        });
    },
    buildSelectedFileMeta(file) {
      return {
        link: URL.createObjectURL(file),
        extension: ". " + (file.name.split(".")[1] || ""),
        title: file.name.split(".")[0] || "",
        _id: file.size + "" + file.lastModified,
        iconURL: "",
      };
    },
    uploadFileToCreatedetail(file, type) {
      const meta = this.buildSelectedFileMeta(file);
      const formData = new FormData();
      formData.append("files[0]", file);
      formData.append("selectedFile[0]", JSON.stringify(meta));
      formData.append("refId", "1");
      formData.append("type", type);
      formData.append("select", "fileUpload");
      return this.$axios.post(this.$endpoint + "createdetail", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    uploadCompanySignatureAndStamp() {
      const app = this;
      const uploads = [];
      if (app.companySignatureEnabled === "active" && app.companySignatureFile) {
        uploads.push(app.uploadFileToCreatedetail(app.companySignatureFile, "signature"));
      }
      if (app.companyStampEnabled === "active" && app.companyStampFile) {
        uploads.push(app.uploadFileToCreatedetail(app.companyStampFile, "stamp"));
      }
      if (uploads.length === 0) {
        return Promise.resolve();
      }
      return Promise.all(uploads).catch((err) => {
        app.serverErrorHandeler(err);
        return Promise.reject(err);
      });
    },
    show() {
      var app = this;
      app.loading = true;
      const settingsUrl = this.$endpoint + "setting/" + 1 + "/edit";
      Promise.all([
        app.$axios.get(settingsUrl, { params: { select: app.select } }),
        app.$axios.get(settingsUrl),
      ])
        .then(([invoiceRes, generalRes]) => {
          app.resetUploadFields();
          app.applyInvoicePrintResponse({
            ...app.normalizeInvoicePrintData(generalRes.data),
            ...app.normalizeInvoicePrintData(invoiceRes.data),
          });
          app.$nextTick(() => {
            app.render = true;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    copied() {
      this.snakbarText = this.$t("copied");
      this.snakbarColor = "blue";
      this.snakbar = true;
    },
    // generatePDF () {
    //   const columns = [
    //     { title: 'ایسن', dataKey: 'title' },
    //     { title: 'Body', dataKey: 'body' },
    //   ]
    //   const doc = new Jspdf({
    //     orientation: 'portrait',
    //     unit: 'in',
    //     format: 'letter',
    //   })
    //   // doc.setFont('IRANSans', 'normal', 'bold')
    //   doc.setLanguage('ar')
    //   // text is placed using x, y coordinates
    //   doc.setFontSize(16).text(this.heading, 0.5, 1.0)
    //   // create a line under heading
    //   doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)
    //   // Using autoTable plugin
    //   autoTable(doc, {
    //     columns,
    //     body: this.items,
    //     margin: { left: 0.5, top: 1.25 },
    //   })
    //   // Using array of sentences
    //   doc
    //     .setFont('helvetica')
    //     .setFontSize(12)
    //     .text(this.moreText, 0.5, 3.5, { align: 'left', maxWidth: '7.5' })
    //
    //   // Creating footer and saving file
    //   doc.text(0, 10, 'Non-utf-8-string')
    //   doc
    //     // .setFont('times')
    //     // .setFontSize(11)
    //     // .setFontStyle('italic')
    //     // .setTextColor(0, 0, 255)
    //     // .text(
    //     //   'This is a simple footer located .5 inches from page bottom',
    //     //   0.5,
    //     //   doc.internal.pageSize.height - 0.5,
    //     // )
    //     .save(`${this.heading}.pdf`)
    // },
  },
};
</script>

<style scoped>
.col {
  height: 55px !important;
}
.upload-col {
  height: auto !important;
  padding: 4px 8px !important;
}
.upload-line {
  display: flex;
  align-items: center;
  gap: 4px;
}
.upload-checkbox {
  flex: 0 0 auto;
  margin: 0 !important;
  padding: 0 !important;
}
.upload-line ::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.upload-zone {
  flex: 0 0 auto;
  width: 200px;
  height: 40px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #ababab;
  border-radius: 4px;
  background: #fafafa;
  cursor: pointer;
  box-sizing: border-box;
}
.upload-zone__text {
  flex: 1;
  min-width: 0;
  text-align: right;
  font-size: 13px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.38);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-zone__text--filled {
  color: rgba(0, 0, 0, 0.87);
}
.upload-zone__icon {
  flex-shrink: 0;
  font-size: 18px !important;
}
.upload-zone__input {
  display: none;
}
</style>
